module.exports = __webpack_public_path__ + "static/media/mmicon.62a10147.png";